import { Context, Inject } from '@nuxt/types/app'
import { Plugin } from '@nuxt/types'
import { Repositories, RepositoriesFactory } from '~/api/RepositoriesFactory/RepositoriesFactory'

declare module 'vue/types/vue' {
  interface Vue {
    $repositories: Repositories
  }
}

declare module '@nuxt/types' {
  interface NuxtAppOptions {
    $repositories: Repositories
  }
  interface Context {
    $repositories: Repositories
  }
}

declare module 'vuex/types/index' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface Store<S> {
    $repositories: Repositories
  }
}

// eslint-disable-next-line import/no-mutable-exports
let $repositories: Repositories

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const plugin: Plugin = (context: Context, inject: Inject) => {
  $repositories = RepositoriesFactory(context.$axios)
  inject('repositories', $repositories)
}

export { $repositories }

export default plugin
